/**
 * @deprecated Usa FilePreviewImageComponent da @sia/file-system
 * Questo componente e mantenuto per retrocompatibilita.
 */
export { FilePreviewImageComponent as AiFilePreviewComponent } from '@sia/file-system';
